import {AppState} from '@/store/state';
import {UiState} from '@/store/ui/state';
import {Component, HostBinding, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppService} from '@services/app.service';
import {Observable} from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user;
    public menu = MENU;

    constructor(
        public appService: AppService,
        private store: Store<AppState>
    ) {}

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
        });
        this.user = this.appService.user;
        console.log(this.user);
    }
}

export const MENU = [
    {
        name: 'Dashboard',
        iconClasses: 'fas fa-tachometer-alt',
        path: ['/']
    },
    {
        name: 'Languages',
        iconClasses: 'fas fa-file',
        path: ['/languages']
    },

    {
        name: 'Courses',
        iconClasses: 'fas fa-file',
        path: ['/courses']
    },
    {
        name: 'Avatars',
        iconClasses: 'fas fa-file',
        path: ['/avatars']
    },
    {
        name: 'Blog',
        iconClasses: 'fas fa-blog',
        path: ['/blog']
    }
    ,
    {
        name: 'Kullanıcılar',
        iconClasses: 'fas fa-users',
        path: ['/users']
    },
    {
        name: 'Rozetler',
        iconClasses: 'fas fa-medal',
        path: ['/badges']
    },
    {
        name: 'Promptlar',
        iconClasses: 'fas fa-robot',
        path: ['/prompts']
    },
    {
        name: 'AI Batch İşleri',
        iconClasses: 'fas fa-layer-group',
        path: ['/gemini-batch-jobs']
    },
    {
        name: 'Bildirimler',
        iconClasses: 'fas fa-bell',
        path: ['/notifications']
    },
    {
        name: 'Premium',
        iconClasses: 'fas fa-crown',
        path: ['/premium']
    }
];
